<template>
  <div style="width: inherit">
    <div v-if="view" id="view" class="view-resume">
      <!--<div class="row view-resume-box">-->
      <!--<div class="col-sm-10 col-md-10 col-lg-10 col-xl-11 view-resume-text">-->
      <!--Something-->
      <!--</div>-->
      <!--<div class="col-sm-2 col-md-2 col-lg-2 col-xl-1 close-icon">-->
      <!--<v-icon color="#ffffff">close</v-icon>-->
      <!--</div>-->
      <!--</div>-->
      <object :data="src" type="application/pdf" width="1000px" height="1000px">
        <embed :src="src" type="application/pdf" />
      </object>
    </div>
  </div>
</template>

<script>
import { DOCUMENT_ACTION } from "../../Api/common_api";

export default {
  name: "document-view",
  props: {
    file: Object
  },
  data: function() {
    return {
      view: false,
      src: "",
      timeout: null
    };
  },
  methods: {
    getView() {
      const self = this;
      let key = self.file.view_key;
      DOCUMENT_ACTION(key, self.$constants.RESUME_ACTION.VIEW)
        .then(function(data) {
          self.view = true;
          self.timeout = setTimeout(function() {
            // let elmnt = document.getElementById("view");
            self.src = data.url;
            // elmnt.scrollIntoView();
          }, 100);
        })
        .catch(function(error) {
          // self.snackbar = true;
          // self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          // self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          // self.snackMessage = error.message;
        });
    }
  },
  beforeDestroy(){
    clearTimeout(this.timeout)
  },
  mounted() {
    const self = this;
    self.getView();
  }
};
</script>

<style scoped>
.view-resume {
  padding: 4rem 1.5rem;
  margin: 2rem !important;
  overflow-y: auto;
}
.view-resume-box {
  height: 4rem;
  padding: 0.8rem;
  background-color: var(--button-color);
  border-radius: 0.3rem 0.3rem 0 0;
}
.view-resume-text {
  font-size: 1.6rem;
  font-weight: bold;
  text-align: left;
  color: #ffffff;
}
.close-icon {
  font-size: 1.6rem;
  text-align: right;
}
::-webkit-scrollbar {
  display: none;
}
</style>
